import { createFileRoute, redirect } from "@tanstack/react-router";
import { INTRO_OFFERS_ENABLED } from "@/lib/introPassPath";
import { CourseTrial } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/course-trial/")({
  // ₹99 trials are paused: send old links to Annual checkout.
  beforeLoad: () => {
    if (!INTRO_OFFERS_ENABLED) throw redirect({ to: "/membership-checkout", search: { plan: "annual" } as never });
  },
  // Transactional step — kept out of the index.
  head: () => seoHead({ title: "Course Trial", noindex: true }),
  component: CourseTrial,
});
